import { render, staticRenderFns } from "./IssuePreview.vue?vue&type=template&id=775df272"
import script from "./IssuePreview.vue?vue&type=script&lang=js"
export * from "./IssuePreview.vue?vue&type=script&lang=js"
import style0 from "./IssuePreview.vue?vue&type=style&index=0&id=775df272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports